import type { User } from "@mc/types"
import { apiRequest } from "./httpClient.js"

/** `/profile` (FR section 12): display name, username, avatar, password change. */
export function updateProfile(input: {
  displayName?: string | null
  username?: string
  avatarUrl?: string | null
  currentPassword?: string
  newPassword?: string
}): Promise<{ user: User }> {
  return apiRequest("/api/v1/auth/me", { method: "PATCH", body: input })
}

/** Live username-uniqueness check while the user types (FR section 12). */
export function checkUsernameAvailable(username: string): Promise<{ available: boolean }> {
  return apiRequest(`/api/v1/auth/username-available?username=${encodeURIComponent(username)}`)
}
